module.exports = __webpack_public_path__ + "img/Analysis.80c0d433.png";